import { i18n } from "../translate/i18n";

// "Criado por Fulano em 22/10/2026 15:30". Ticket aberto por integracao (sem
// usuario) mostra so a data.
export const formatInternalTicketCreation = (internalTicket, textKey) => {
  if (!internalTicket?.createdAt) return "";
  const date = new Date(internalTicket.createdAt).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
  const name = internalTicket.createdByUser?.name;
  // Sem o escape de HTML do i18next: quem desenha e o React, e "D'Avila"
  // viraria "D&#39;Avila" na tela.
  const interpolation = { escapeValue: false };
  return name
    ? i18n.t(`${textKey}.createdBy`, { name, date, interpolation })
    : i18n.t(`${textKey}.createdAt`, { date, interpolation });
};

export const formatInternalTicketProtocol = (internalTicket) => {
  if (!internalTicket?.id || !internalTicket?.createdAt) return "-";

  const date = new Date(internalTicket.createdAt);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);

  return `INT-${day}${month}${year}-${internalTicket.id}`;
};

export const getInternalTicketPriorityLabel = (priority) => {
  if (!priority) return "-";
  return i18n.t(`internalTickets.labels.priority.${priority}`) || priority;
};

export const getInternalTicketStatusLabel = (status) => {
  if (!status) return "-";
  return i18n.t(`internalTickets.labels.status.${status}`) || status;
};

export const getInternalTicketSlaLabel = (slaStatus) => {
  if (!slaStatus) return "-";
  return i18n.t(`internalTickets.labels.sla.${slaStatus}`) || slaStatus;
};
